import { CardDataType, ComponentName } from "../types";

export class ShowAllCardData {
    constructor(
        private readonly itemClass: string,
        private readonly name: string
    ) { }

    getName(): string {
        return `${this.name}`;
    }

    getId(): string {
        return "show-all";
    }

    getClass(): string {
        return `${this.itemClass}`;
    }

    getType(): CardDataType {
        return CardDataType.ShowAll;
    }

    getComponentName(): ComponentName {
        return ComponentName.SHOW_ALL;
    }
}
